import styles from "./scroll-bar.module.scss";
import type { ScrollBarViewProps } from "./types-scroll-bar";

export function ScrollBarView({
  visible,
  orientation,
  controls,
  testId,
  className,
  style,
  rest,
  rootRef,
  onKeyDown,
  children,
}: ScrollBarViewProps) {
  if (!visible) return null;

  return (
    <div
      ref={rootRef}
      className={[styles.root, className].filter(Boolean).join(" ")}
      style={style}
      data-testid={testId}
      data-orientation={orientation}
      {...rest}
      role="scrollbar"
      tabIndex={0}
      aria-controls={controls}
      aria-orientation={orientation}
      aria-valuemin={0}
      aria-valuemax={100}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  );
}
